import { QueryResolvers, VirtualObjectType } from '@spazious/dollhouse-graphql';

import { ApolloContext } from '../context.js';
import { getDecorations, getFurnitures } from '../helpers/index.js';

/**
 * Resolver for the virtualObjects query.
 */
export const virtualObjects: QueryResolvers<ApolloContext>['virtualObjects'] = async (
  _,
  variables,
  context
) => {
  const { spaceId } = variables;
  const { api } = context;

  const emptyResponse = {
    data: [],
    pagination: {
      hasNext: false,
    },
  };

  const furnitures =
    !variables.type || variables.type === VirtualObjectType.Furniture
      ? await getFurnitures(api, spaceId, variables.pageNumber ?? 1)
      : emptyResponse;

  const decorations =
    !variables.type || variables.type === VirtualObjectType.Decoration
      ? await getDecorations(api, spaceId, variables.pageNumber ?? 1)
      : emptyResponse;

  return {
    data: [...furnitures.data, ...decorations.data],
    pagination: {
      hasNext: furnitures.pagination.hasNext || decorations.pagination.hasNext,
    },
  };
};
